import { nameof } from "../../../../utils/nameof";
import { DescribeMissingField } from "../../utils/missingFields.utils";
import { DonationsFormValues } from "./DonationsView.types";
import { DONATION_QUESTIONS } from "./DonationsView.utils";

const TAB = "clients.client.debtSettlement.assetInventory.donationsTab";
const ANSWERS = nameof<DonationsFormValues>("answers");

export const describeMissingDonationField: DescribeMissingField<DonationsFormValues> = ({ field }, _values, t) => {
  for (const { key, field: questionField, detailsField } of DONATION_QUESTIONS) {
    if (field === questionField) {
      return { path: `${ANSWERS}.${field}`, message: t(`${TAB}.${key}.questionRequired`) };
    }
    if (field === detailsField) {
      return { path: `${ANSWERS}.${field}`, message: t(`${TAB}.${key}.detailsRequired`) };
    }
  }
  return undefined;
};
